// Firebase Configuration Types
export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
}

const normalizeAuthDomain = (value: string | undefined): string => {
  if (!value) return '';

  return value
    .trim()
    .replace(/^https?:?\/\//i, '')
    .replace(/\/+$/, '');
};

// Environment Variables
export const firebaseConfig: FirebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  // Firebase expects host only (e.g. studio.drahft.com), not a full URL.
  authDomain: normalizeAuthDomain(import.meta.env.VITE_FIREBASE_AUTH_DOMAIN),
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
export const firebaseVapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY || '';

// API Base URL - Split deployment (client on www, server on separate project)
const rawBaseUrl =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.PROD ? 'https://drahft.com/api' : 'http://localhost:5252/api');

// Ensure URL always ends with /api
export const apiBaseUrl = rawBaseUrl.endsWith('/api')
  ? rawBaseUrl
  : `${rawBaseUrl.replace(/\/$/, '')}/api`;

export const widgetCdnUrl = import.meta.env.VITE_WIDGET_CDN_URL || 'https://cdn.drahft.com';
